import { sec } from './units.ts';

/*
 * Ansel, the Ash Scholar (mage; docs/ANTIHEROES.md, "Los siete que faltan"): he burned the library so the nightmares
 * would not have it. The titan dreams him in black glass cracked with fire, still carrying its ash. He punishes towers
 * built close together and a channel nobody cuts. His damage to heroes, as every Unsleeping's, is at least a share of
 * the hero's own health, through armour and shields.
 */
export const ANSEL = {
  /** His shots reach this far; he stands and shoots while a hero is in it. */
  range: 5500,
  /** Each shot: at least this share of the struck hero's max health, on the target and every hero within `splash` of it. */
  blowMaxHpBp: 700,
  splash: 1000,
  /** Burnt pages: every `every`, the most wounded nightmare within `radius` of him is covered in ash that soaks `ash` (by his strength). */
  pages: { every: sec(8), radius: 4500, ash: 150 },
  /**
   * Wandering ember: a slow ember (`step` a tick, slower than any hero) chases a hero within `range` for `ticks`. It
   * bursts on reaching a hero (`hit`), touching a tower (`touch`; the tower is left burning) or at the end: heroes within
   * `radius` take `damage` or `maxHpBp` of their health. Two embers, at two heroes, from his second phase.
   */
  ember: { every: sec(7), range: 7500, ticks: sec(4), step: 85, hit: 450, touch: 700, radius: 1300, damage: 50, maxHpBp: 2000, burn: { ticks: sec(6), dmg: 20 } },
  /**
   * Ash wall: a wall of fire `cells` long (fires of `radius` every `spacing`) across the way between him and the heroes,
   * at least `near` from him. Each pulse (`pulse`) it burns the heroes in it; towers within `silence` of it can't shoot
   * while it burns.
   */
  wall: { every: sec(15), range: 7000, near: 1500, cells: 6, spacing: 1000, radius: 600, ticks: sec(6), pulse: sec(0.5), damage: 30, maxHpBp: 800, silence: 1100 },
  /**
   * The library burns (ultimate): columns of fire marked on the tightest towers within `range` (`towers` by phase).
   * Landing, each tower loses `towerBp` of its health and is left burning and silent `ticks`; heroes within `radius`
   * of a column take `damage` or `maxHpBp` of their health. With no tower in reach, the columns fall on the heroes.
   */
  library: { range: 12000, towers: [3, 3, 5] as readonly number[], radius: 1100, towerBp: 6000, ticks: sec(10), burnDmg: 25, damage: 120, maxHpBp: 4000 },
  /** From his last phase: a ring of ash; heroes within `radius` that stood still `still` burn every `pulse`. */
  ring: { radius: 2400, still: sec(1), pulse: sec(0.5), damage: 25, maxHpBp: 600 },
};
